import {
  login as loginService,
  VendorRegisterSelf,
  getAllClients,
  ResetPassword
} from "services/authService";
import {
  loginStart,
  loginSuccess,
  loginFailure,
  VendorRegSlefStart,
  VendorRegSlefSuccess,
  VendorRegSlefFailure,
  getAllClientsSucess,
  getAllClientsFailure,
  getAllClientsStart,
  ChangePasswordStart,
  ChangePasswordSuccess,
  ChangePasswordFailure
} from "store/features/auth/authSlices";
import {
  setSecureLocalItem,
  removeSecureLocalItem,
} from "utils/secureSessionStorage";
import { showSuccessToast } from "utils/toastNotification";
import { showErrorToast } from "utils/toastNotification";

//login Action
export const login = (credentials) => async (dispatch) => {
  try {
    dispatch(loginStart());
    const result = await loginService(credentials);

    if (result.meta.status === true) {
      setSecureLocalItem("token", result.data.token);
      setSecureLocalItem("role", result.data.user.role);
      dispatch(loginSuccess(result.data));
    } else {
      throw new Error(result.message);
      showErrorToast("Login Failed  !")
    }
  } catch (error) {
    dispatch(loginFailure(error.message));
          showErrorToast("Login Failed ! Please Check Phone Number and Password.")
  }
};

//Reset Password by admin 
export const ResetPasswordAction = (infoData) => async (dispatch) => {
  try {
    dispatch(ChangePasswordStart());
    const result = await ResetPassword(infoData);
    if (result.meta.status === true) {
      dispatch(ChangePasswordSuccess(result.data));
      showSuccessToast("Password Reset Successfully !");
    }
  } catch (error) {
    dispatch(ChangePasswordFailure(error.message));
    showErrorToast("Old password is incorrect");
  }
};

//Vendor Register Self
export const VendorSelfReg = (infoData) => async (dispatch) => {
  try {
    dispatch(VendorRegSlefStart());
    const result = await VendorRegisterSelf(infoData);
    if (result.success) {
      dispatch(VendorRegSlefSuccess(result.data));
    } else {
      throw new Error(result.message);
    }
  } catch (error) {
    dispatch(VendorRegSlefFailure(error.message));
  }
};

//logout
export const logoutAction = () => async (dispatch) => {
  try {
    removeSecureLocalItem("token");
    removeSecureLocalItem("role");
  } catch (error) {
    console.error("Logout failed:", error);
  }
};

//Get all registered clients
export const getAllClientsAction = () => async (dispatch) => {
  try {
    dispatch(getAllClientsStart());
    const result = await getAllClients();
    dispatch(getAllClientsSucess(result.data));
  } catch (error) {
    dispatch(getAllClientsFailure(error.message));
  }
};
